/* import __COLOCATED_TEMPLATE__ from './loan-row.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();